import React, { useState, useEffect } from 'react';
import EOPF from './EOPF.module.css';

const EditOrderedProductForm = ({ currentAttributes, onSave, onClose }) => {
    const [dateDeliveredMonth, setDateDeliveredMonth] = useState('');
    const [dateDeliveredYear, setDateDeliveredYear] = useState('');
    const [lastServiceMonth, setLastServiceMonth] = useState('');
    const [lastServiceYear, setLastServiceYear] = useState('');
    const [nextServiceMonth, setNextServiceMonth] = useState('');
    const [nextServiceYear, setNextServiceYear] = useState('');

    useEffect(() => {
        if (currentAttributes.date_delivered) {
            const date = new Date(currentAttributes.date_delivered);
            setDateDeliveredMonth((date.getMonth() + 1).toString().padStart(2, '0'));
            setDateDeliveredYear(date.getFullYear().toString());
        }
        if (currentAttributes.date_performed) {
            const date = new Date(currentAttributes.date_performed);
            setLastServiceMonth((date.getMonth() + 1).toString().padStart(2, '0'));
            setLastServiceYear(date.getFullYear().toString());
        }
        if (currentAttributes.next_service_date) {
            const date = new Date(currentAttributes.next_service_date);
            setNextServiceMonth((date.getMonth() + 1).toString().padStart(2, '0'));
            setNextServiceYear(date.getFullYear().toString());
        }
    }, [currentAttributes]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const dateDelivered = `${dateDeliveredYear}-${dateDeliveredMonth}-01`;
        const lastService = `${lastServiceYear}-${lastServiceMonth}-01`;
        const nextService = `${nextServiceYear}-${nextServiceMonth}-01`;
        onSave({
            ...currentAttributes,
            date_delivered: dateDelivered,
            date_performed: lastService,
            next_service_date: nextService
        });
        onClose();
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group">
                <label htmlFor="dateDeliveredMonth">Leveringsmåned:</label>
                <select
                    id="dateDeliveredMonth"
                    className="form-control"
                    value={dateDeliveredMonth}
                    onChange={(e) => setDateDeliveredMonth(e.target.value)}
                >
                    <option value="">Velg måned</option>
                    {Array.from({ length: 12 }, (_, i) => {
                        const monthValue = (i + 1).toString().padStart(2, '0');
                        return (
                            <option key={monthValue} value={monthValue}>
                                {new Date(0, i).toLocaleString('nb-NO', { month: 'long' })}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="dateDeliveredYear">Leveringsår:</label>
                <input
                    type="text"
                    className="form-control"
                    id="dateDeliveredYear"
                    value={dateDeliveredYear}
                    onChange={(e) => setDateDeliveredYear(e.target.value)}
                    placeholder="YYYY"
                    pattern="\d{4}"
                />
            </div>
            <div className="form-group">
                <label htmlFor="lastServiceMonth">Forrige service måned:</label>
                <select
                    id="lastServiceMonth"
                    className="form-control"
                    value={lastServiceMonth}
                    onChange={(e) => setLastServiceMonth(e.target.value)}
                >
                    <option value="">Velg måned</option>
                    {Array.from({ length: 12 }, (_, i) => {
                        const monthValue = (i + 1).toString().padStart(2, '0');
                        return (
                            <option key={monthValue} value={monthValue}>
                                {new Date(0, i).toLocaleString('nb-NO', { month: 'long' })}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="lastServiceYear">Forrige service år:</label>
                <input
                    type="text"
                    className="form-control"
                    id="lastServiceYear"
                    value={lastServiceYear}
                    onChange={(e) => setLastServiceYear(e.target.value)}
                    placeholder="YYYY"
                    pattern="\d{4}"
                />
            </div>
            <div className="form-group">
                <label htmlFor="nextServiceMonth">Neste service måned:</label>
                <select
                    id="nextServiceMonth"
                    className="form-control"
                    value={nextServiceMonth}
                    onChange={(e) => setNextServiceMonth(e.target.value)}
                >
                    <option value="">Velg måned</option>
                    {Array.from({ length: 12 }, (_, i) => {
                        const monthValue = (i + 1).toString().padStart(2, '0');
                        return (
                            <option key={monthValue} value={monthValue}>
                                {new Date(0, i).toLocaleString('nb-NO', { month: 'long' })}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className="form-group">
                <label htmlFor="nextServiceYear">Neste service år:</label>
                <input
                    type="text"
                    className="form-control"
                    id="nextServiceYear"
                    value={nextServiceYear}
                    onChange={(e) => setNextServiceYear(e.target.value)}
                    placeholder="YYYY"
                    pattern="\d{4}"
                />
            </div>
            <button type="submit" className={EOPF.button}>Lagre</button>
        </form>
    );
};

export default EditOrderedProductForm;